import { Component } from '@angular/core'
import { AnalyticsService } from 'app/core/services'
import { Onboarding, OnboardingService } from '../../../../services/onboarding'
import { ViewDidEnter } from '@ionic/angular'

@Component({
	selector: 'hum-uniqueness',
	templateUrl: './uniqueness.component.html',
	styleUrls: ['./uniqueness.component.scss'],
})
export class UniquenessComponent implements ViewDidEnter {
	onboarding: Onboarding | null

	constructor(private onboardingService: OnboardingService, private analytics: AnalyticsService) {
		this.onboardingService.intro_data.subscribe((onboarding) => {
			this.onboarding = onboarding
		})
	}

	ionViewDidEnter() {
		this.analytics.logOnboardingEvent('onb_unique')
	}

	get screen() {
		return this.onboarding?.hd_uniq
	}

	navigateNext() {
		this.onboardingService.navigateNext()
	}
}
